import { mapGetters } from "vuex";
import roleFunctions from "@/data/functions/mixins/roleFunctions.js";
import role from "@/data/forms/mixins/role.js";
import moment from "moment";

export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [roleFunctions, role],
  computed: {
    ...mapGetters(["getUser"])
  },
  methods: {
    generateSingleRole(tag) {
      // HELP
      console.log("SINGLE ROLE");
      console.log(tag);
      // NEW ROLE
      let tempForm = this.generateRoleForm();
      tempForm.basic.tag = "G4";
      tempForm.basic.idg = this.generateIDG("date-gid");
      tempForm.basic.did = this.generateDID("auto");
      tempForm.basic.idi = 1;
      tempForm.basic.title = this.generateRoleInfo(tag).title;
      tempForm.char.obj = this.generateRoleInfo(tag).obj;
      tempForm.char.type = this.generateRoleInfo(tag).type;
      tempForm.char.theme = this.generateRoleInfo(tag).theme;
      tempForm.char.resp = this.generateRoleInfo(tag).resp;
      tempForm.char.ref = "";
      tempForm.char.icon = this.selectIconFromRole(tempForm.char.type);
      tempForm.stats.date = moment().format();
      tempForm.stats.uname = this.getUser.basic.title;
      tempForm.stats.uemail = this.getUser.basic.email;
      tempForm.stats.udid = this.getUser.basic.did;

      // ROLES LIST
      let tempList = [];
      let obj = Object.assign({}, tempForm);
      let parseobj = JSON.parse(JSON.stringify(obj));
      let newList = this.appendItemLimited(parseobj, tempList, 6);

      // RETURN
      return newList;
    },
    generateRoleInfo(tag) {
      let role = {
        type: "Type NA",
        title: "Title NA",
        obj: "Obj NA",
        resp: "Resp NA"
      };

      // DEFINE TYPE / TITLE / OBJECTIVE
      if (tag === "B1") {
        role.title = "Risk Owner";
        role.type = "Custodian";
        role.theme = "Safety";
        role.obj = "Offer advice on risks asseessment.";
      }
      if (tag === "B3") {
        role.title = "Action Lead";
        role.type = "Assignee";
        role.theme = "Action";
        role.obj = "Complete action as per scope.";
      }
      if (tag === "C1") {
        role.title = "Company Director";
        role.type = "Custodian";
        role.theme = "Manage";
        role.obj = "Corporate management and strategy development.";
      }
      if (tag === "E1") {
        role.title = "Equipment Custodian";
        role.type = "Custodian";
        role.theme = "Process";
        role.obj = "Manage equipment data for company and / or facility.";
      }
      if (tag === "E6") {
        role.title = "Results Custodian";
        role.type = "Custodian";
        role.theme = "Process";
        role.obj = "Manage the inspection and test result requirements.";
      }
      if (tag === "S1") {
        role.title = "Health and Safety Advisor";
        role.type = "Custodian";
        role.theme = "Safety";
        role.obj = "Approve the .";
      }
      if (tag === "W6") {
        role.title = "Procedure Custodian";
        role.type = "Custodian";
        role.theme = "Process";
        role.obj = "Manage the life cycle of the procedure.";
      }
      // ROLE RESPOSIBILITY Description
      let resp = "Please seek clarification from the Company Director ";
      resp = resp + "or Facility Manager if " + role.theme;
      resp = resp + " " + role.type;
      resp = resp + " is not available.";
      role.resp = resp;

      return role;
    },
    generateTwoRoles(tag) {
      // ROLES LIST
      let newList = [];
      let obj1 = null;
      let parseobj1 = null;
      let obj2 = null;
      let parseobj2 = null;
      if (tag === "B3") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assignee",
            "Action Assignee",
            "Complete assigned action.",
            "General"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Action Supervisor",
            "Validate action was completed as per the scope with quality outcome.",
            "Leader"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
      }
      if (tag === "B4") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assignee",
            "Budget Coordinator",
            "Manage budget approval process and cost managment.",
            "Finance"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Badger Approver",
            "Approve new budgets and budget variations.",
            "Manager"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
      }
      if (tag === "B6") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assignee",
            "Planner",
            "Manage plan addition, resource plan, respect plan limits.",
            "Finance"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Plan Approver",
            "Approve new plans and plan variations.",
            "Manager"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
      }
      if (tag === "Q1") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assignee",
            "Purchase Officer",
            "Complete order using approved budget as per request.",
            "General"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Accountant",
            "Validate spending process and profile. Approve high expenditure items.",
            "Leader"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
      }
      // RETURN
      return newList;
    },
    generateThreeRoles(tag) {
      // ROLES LIST
      let newList = [];
      let obj1 = null;
      let parseobj1 = null;
      let obj2 = null;
      let parseobj2 = null;
      let obj3 = null;
      let parseobj3 = null;
      if (tag === "E2") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assigneed",
            "Engineer",
            "Develop technical solution for defined problem.",
            "Safety"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Senior Engineer",
            "Confirm process is followed and sound economically. Recommend technical solution to the business.",
            "Safety"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
        // ROLE 3
        obj3 = Object.assign(
          {},
          this.generateRoleDetail(
            3,
            "Manager",
            "Project Sponsor",
            "Agree or reject proposed technical solution and release project resources.",
            "Safety"
          )
        );
        parseobj3 = JSON.parse(JSON.stringify(obj3));
        newList = this.appendItemLimited(parseobj3, newList, 6);
      }
      if (tag === "F1") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Superintendent",
            "Operations Superintendent ",
            "Responsible for day-to-day plant operations including permit to work system management.",
            "Manage"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "HSE",
            "Health and Safety Manager",
            "Responsible for processes and system that ensure safe operation during normal and maintenance.",
            "Safety"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
        // ROLE 3
        obj3 = Object.assign(
          {},
          this.generateRoleDetail(
            3,
            "Manager",
            "Facility Manager",
            "Facility leader responsible for business plans and budget process to ensure safe, reliable and low carbon operations.",
            "ManageSSS"
          )
        );
        parseobj3 = JSON.parse(JSON.stringify(obj3));
        newList = this.appendItemLimited(parseobj3, newList, 6);
      }
      if (tag === "M2") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assignee",
            "Strategy Coordinator",
            "Maintenance Strategy developer.",
            "Safety"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Asset Engineer",
            "Maintenance Strategy recommender and reviewer.",
            "Safety"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
        // ROLE 3
        obj3 = Object.assign(
          {},
          this.generateRoleDetail(
            3,
            "Manager",
            "Strategy Custodian",
            "Maintenance Strategy approver and sponsor.",
            "Safety"
          )
        );
        parseobj3 = JSON.parse(JSON.stringify(obj3));
        newList = this.appendItemLimited(parseobj3, newList, 6);
      }
      if (tag === "M5") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Assignee",
            "Plan Coordinator",
            "Maintenance Plan developer and detailed designer.",
            "Safety"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Supervisor",
            "Plan Engineer",
            "Maintenance Plan recommender and reviewer.",
            "Safety"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
        // ROLE 3
        obj3 = Object.assign(
          {},
          this.generateRoleDetail(
            3,
            "Manager",
            "Plan Custodian",
            "Maintenance Plan approver and sponsor.",
            "Safety"
          )
        );
        parseobj3 = JSON.parse(JSON.stringify(obj3));
        newList = this.appendItemLimited(parseobj3, newList, 6);
      }
      if (tag === "S6") {
        // ROLE 1
        obj1 = Object.assign(
          {},
          this.generateRoleDetail(
            1,
            "Reporter",
            "Incident Reporter",
            "Define event details, time, location.",
            "Safety"
          )
        );
        parseobj1 = JSON.parse(JSON.stringify(obj1));
        newList = this.appendItemLimited(parseobj1, newList, 6);
        // ROLE 2
        obj2 = Object.assign(
          {},
          this.generateRoleDetail(
            2,
            "Investigator",
            "Investigation Lead",
            "Define event details, time, location.",
            "Safety"
          )
        );
        parseobj2 = JSON.parse(JSON.stringify(obj2));
        newList = this.appendItemLimited(parseobj2, newList, 6);
        // ROLE 3
        obj3 = Object.assign(
          {},
          this.generateRoleDetail(
            3,
            "Manager",
            "Investigantion Sponsor",
            "Define event details, time, location.",
            "Safety"
          )
        );
        parseobj3 = JSON.parse(JSON.stringify(obj3));
        newList = this.appendItemLimited(parseobj3, newList, 6);
      }
      // RETURN
      return newList;
    },
    generateRoleDetail(idi, type, title, obj, theme) {
      let tempForm = this.generateRoleForm();
      tempForm.basic.tag = "G4";
      tempForm.basic.idg = this.generateIDG("date-gid");
      tempForm.basic.did = this.generateDID("auto");
      tempForm.basic.idi = idi;
      tempForm.basic.title = title;
      tempForm.char.obj = obj;
      tempForm.char.type = type;
      tempForm.char.theme = theme;
      tempForm.char.ref = "";
      tempForm.char.icon = this.selectIconFromRole(tempForm.char.type);

      // ROLE RESPOSIBILITY Description
      let resp = "Please seek clarification from the Company Director ";
      resp = resp + "or Facility Manager if " + tempForm.char.theme;
      resp = resp + " " + tempForm.char.type;
      resp = resp + " is not available.";
      tempForm.char.resp = resp;

      // STATS
      tempForm.stats.date = moment().format();
      tempForm.stats.uname = this.getUser.basic.title;
      tempForm.stats.uemail = this.getUser.basic.email;
      tempForm.stats.udid = this.getUser.basic.did;
      return tempForm;
    }
  }
};
